import React from 'react';

const Image_webp = ({ text }) => {
  return (
    <img
      src={`assets/img/${text}.webp`}
      alt={text}
      loading="lazy"
    />
  );
};

export default Image_webp;
